<template>
  <div class="info-edit">
    <div class="row justify-content-between  scroll-container" v-if="!renderAgreementInfo">
      <div class="notes mt-2 mb-4 padding-5 ps-3 pe-3" style="background: #f9f9f9; padding:5px;" v-for="(agreementText, index) in agreementTexts" :key="agreementText.text_body">
        <div style="padding:2px 5px;">
          <div v-html="agreementText.text_head">
            <span>{{index}}</span>
          </div>
          <div v-html="agreementText.text_body">
          </div>
        </div>
      </div>
    </div>
    <div v-if="!renderAgreementInfo">
      <button  @click="renderAgreementInfo = true"
               class="btn btn-personal-info-edit btn-outline-info info-edit-btn w-100 mt-4"
      >
        <i class="fas fa-pen me-2"></i>
        Edit Details
      </button>
    </div>
    <div  v-if="renderAgreementInfo">
      <agreement-and-signature :isRedirectionFromReview="true"
                               @cancelEditInfo="cancelEditInfo"
                               @updatedEditInfo="updatedEditInfo"/>
    </div>
  </div>
</template>

<script>
import AgreementAndSignature from "../AgreementAndSignature";
export default {
  name: "AgreementEdit",
  props: {
    agreementTexts: {
      type: Object
    }
  },
  data () {
    return {
      renderAgreementInfo: false
    }
  },
  components: {
    AgreementAndSignature
  },
  methods: {
    cancelEditInfo () {
      let app = this
      app.renderAgreementInfo = false
    },
    updatedEditInfo () {
      let app = this
      app.renderAgreementInfo = false
      app.$emit('updatedEditInfo')
    }
  }
}
</script>
<style src="@/assets/css/review_edit.css"></style>
<style scoped></style>